import React, { PropsWithChildren } from 'react';

import { Modal } from '@swyftx/aviary/atoms/Modal';
import { MarginOrderDirection } from '@swyftx/margin/build/types';

import { MarginTradePanel } from './MarginTradePanel';
import { SwyftxMarginStalePriceBanner } from '../../General/SwyftxMarginStalePriceBanner';

type Props = {
  initialTradeSide?: MarginOrderDirection;
};

const MarginTradePanelModal: React.FC<PropsWithChildren<Props>> = ({ initialTradeSide, children }) => (
  <Modal
    position='fullscreen'
    title='Open position'
    triggerElement={children}
    className='sm:min-w-[600px] md:min-w-[600px] '
  >
    <SwyftxMarginStalePriceBanner containerClassName='p-16 md:hidden' />
    <MarginTradePanel initialTradeSide={initialTradeSide} modalPosition='dynamic' />
  </Modal>
);

export { MarginTradePanelModal };
